import { render } from "./media-content-v2.vue?vue&type=template&id=fa37b24a"
import script from "./media-content-v2.vue?vue&type=script&lang=js"
export * from "./media-content-v2.vue?vue&type=script&lang=js"

import "./media-content-v2.vue?vue&type=style&index=0&id=fa37b24a&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/media-content-v2.vue'],['render',render],['__file',"media-content-v2.vue"]])

export default __exports__